import { useForm, Controller } from 'react-hook-form';
import { FormProvider, TextField, Table, Checkbox, SelectTag } from '../../../../../../components';
import { Button, Container, Paper, Stack, Typography, Select, MenuItem, Dialog, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { BASE_URL, request } from '../../../../../../utils';
import { toast } from 'react-toastify';
import { useCallback } from 'react';
import { dropdownFetch } from '../../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../../components';
import axios from 'axios';
import { SelectDoctorTable } from './SelectDoctorTable';

const TABLE_COLUMNS = [
  {
    header: 'User Name',
    accessor: (row) => `${row.user.first_name} ${row.user.last_name}`
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  },
  {
    header: 'Created At',
    accessor: 'createdAt'
  }
];

const DOCTOR_TABLE_COLUMN = [
  {
    header: 'Doctor Name',
    accessor: (row) => row.name
  }
];

const initialDoctorMappingDataObj = {
  data: [],
  loading: false
};

export const UserWiseDoctorMapping = () => {
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [doctorMappingDataObj, setDoctorMappingDataObj] = useState(initialDoctorMappingDataObj);
  const [loading, setLoading] = useState(false);
  const [groupDropdown, setGroupDropdown] = useState([]);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [userList, setUserList] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        user: Yup.string().required('User Name is required')
      })
    ),
    defaultValues: {
    },
    mode: 'all'
  });

  const { handleSubmit, setValue, reset, watch } = methods;

  const getUserList = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/user`);
      setUserList(response.data);
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
  }, []);

  useEffect(() => {
    getUserList();
  }, []);

  const getDoctorList = useCallback(async () => {
    try {
      const response = await axios.get(`${BASE_URL}/doctor/list`);
      setDoctorList(response.data);
    } catch (error) {
      console.error('Error fetching user list:', error);
    }
  }, []);

  useEffect(() => {
    getUserList();
    getDoctorList();
  }, []);

  useEffect(() => {
    if (selectedRecord) {
      setValue('user', selectedRecord.user._id);
    } else {
      reset();
    }
  }, [setValue, reset, selectedRecord]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/user-wise-doctor-mapping-update' : '/user-wise-doctor-mapping-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        user: formValues.user,
        selectedDoctors: selectedRows
      }
    });
    if (response?.success) {
      toast.success(`Successfully ${editFlag ? 'edited' : 'created'} User Wise Doctor Mapping`);
      setSelectedRecord(response.data);
      setCurrentAction();
    } else {
      toast.error(`Failed to ${editFlag ? 'edit' : 'create'} User Wise Doctor Mapping`);
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/subgroup-master-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully Cancelled User Wise Doctor Mapping', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to Cancelled User Wise Doctor Mapping', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/subgroup-master-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted User Wise Doctor Mapping', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete User Wise Doctor Mapping', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setDoctorMappingDataObj({ loading: true });
    const response = await request('/user-wise-doctor-mapping-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDoctorMappingDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDoctorMappingDataObj({ loading: false });
    }
  };

  const isSelected = (row, field) => {
    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      return false;
    }
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }

    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      setSelectedRows([]);
      return;
    }

    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);

      if (existingRow) {
        if (existingRow[field]) {
          return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
        } else {
          return prevSelectedRows.map((selectedRow) =>
            selectedRow._id === row._id ? { ...selectedRow, [field]: true } : selectedRow
          );
        }
      } else {
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  useEffect(() => {
    if (selectedRecord && selectedRecord.selectedDoctors) {
      const initialSelectedRows = selectedRecord.selectedDoctors.map((doctor) => ({
        _id: doctor._id,
        name: doctor.name,
        ok: true
      }));
      setSelectedRows(initialSelectedRows);
    }
  }, [selectedRecord]);


  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                User Wise Doctor Mapping
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setSelectedRows([])
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Stack gap={0.1}>
              <Box
                sx={{
                  border: '0px solid gray',
                  padding: 2,
                  borderRadius: '8px',
                  width: '70%',
                  boxShadow: '0px 2px 10px #0099ff'
                }}
              >
                <Stack spacing={2} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.15, fontSize: '1.4rem', fontWeight: 700 }}>Users</Typography>
                  <SelectTag
                    disabled={!['new', 'edit'].includes(currentAction)}
                    formControlSX={{ flex: 0.7, border: currentAction ? '0.5px solid red' : '' }}
                    name="user"
                    menus={userList.map((data) => ({ ...data, name: `${data.first_name} ${data.last_name}` }))}
                  />
                </Stack>
                <Stack
                  padding={0.2}
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom="1px solid"
                  borderColor="grey.300"
                  marginTop="2%"
                >
                  <SelectDoctorTable
                    sx={{ mt: 0.5 }}
                    columns={DOCTOR_TABLE_COLUMN}
                    data={(watch('user') && doctorList.data) || []}
                    loading={setDoctorMappingDataObj.loading}
                    showOk={true}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    currentAction={currentAction}
                  />
                </Stack>
              </Box>
            </Stack>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 1.5 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0.2}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Doctor Wise Doctor Mapping Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_COLUMNS}
          data={doctorMappingDataObj.data || []}
          loading={doctorMappingDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
    </>
  );
};
